
define('modules/application/wizard/classes/ecoMode',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"
],

function(app, Backbone, genericElement) {
  var ecoModeEventAggregator = _.extend({}, Backbone.Events);
  var ecoMode                = _.extend({}, genericElement, {

    Views : {

      titleBar  : genericElement.Views.titleBar.extend({
        template        : "application/wizard/sections/ecoMode/titleBar",
        tagName         : "h3",
        eventAggregator : ecoModeEventAggregator,

        serialize                      : function()                  {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        initialize                    : function() {
          this.model.bind("updateViews", this.setLabel);

          this.eventAggregator.bind("view:open",this.open, this);
          this.eventAggregator.bind("view:close",this.close, this);

          this.model.unbind("change:inhibited", this.render);
          this.model.bind("change:inhibited", this.render, this);

          this.model.unbind("insertEcoMode", this.setDetails);
          this.model.bind("insertEcoMode", this.setDetails, this);

          this.model.titleBarView = this;
        },
        setDetails                        : function(id)                           {
          if(this.model.get("ecoModeRequired")){
            this.$el.find(".caption").text("funzione inserita");
            this.$el.find(".caption").fadeIn(200);
          }else{
            this.$el.find(".caption").text("");
            this.$el.find(".caption").fadeOut(200);
          }
        },

        setLabel                      : function() {
          if ((this.get("packageClassLabel"))&&(this.get("packageClassLabel")!==""))
          {
            this.titleBarView.$el.find(".titleBarcontent span").html($.i18n._(this.get("packageClassLabel")));
            this.titleBarView.$el.find(".titleBarcontent span").fadeIn(200);
          }
          else{
            this.titleBarView.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
            this.setDetails();
          }
        },

        removeLabel                   : function() {
          this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        enable                        : function() {
          this.$el.trigger("click");
        },

        disable                       : function() {
          this.$el.trigger("click");
        }
      }),

      content   : genericElement.Views.content.extend({
        template        : "application/wizard/sections/ecoMode/content",
        className       : "ecoMode",
        eventAggregator : ecoModeEventAggregator,

        events    : {
          "click .radio"              :  "ecoModeChanged",
          "change #interface"         :  "interfaceChanged",
          "click .checkbox"           :  "oneInterfaceForEachZoneChanged",
          "click .toggleInfoButton"   :  "toggleInfos"
        },

        initialize                       : function()                  {
          var that = this;
          this.model.set("view",this);

          this.eventAggregator.unbind("view:enable", this.enableSection, this);
          this.eventAggregator.bind("view:enable",   this.enableSection, this);

          this.eventAggregator.unbind("view:disable",this.disableSection, this);
          this.eventAggregator.bind("view:disable",  this.disableSection, this);

          this.model.unbind("change:inhibited",      this.render);
          this.model.bind("change:inhibited",        this.render, this);

          if ((BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel"))&&(BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel").get("maxZoneNumber")==4))
            this.model.set("inhibited", true);
          else
            this.model.set("inhibited", false);
        },

        serialize                        : function()                  {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        cleanup: function() {
          this.model.off(null, null, this);
        },

        toggleInfos : function(e) {
          return genericElement.Views.content.prototype.toggleInfos(e, this);
        },

        disableSection                   : function()                  {
          this.$el.find("select#interface").attr("disabled","disabled");
          this.$el.find("select#interface").removeAttr("rel");
          this.$el.find("select#interface option").removeAttr("selected");
          $(this.$el.find("select#interface option")[0]).attr("selected","selected");

          this.$el.find(".oneInterfaceForEachZone").attr("disabled","disabled");
          this.$el.find(".oneInterfaceForEachZone").removeAttr("checked");
          this.$el.find(".oneInterfaceForEachZone").removeAttr("rel");

          this.$el.find(".exampleImage").attr("src","");

          this.$el.find(".checkbox").remove();
          this.$el.find(".radio").remove();
          this.$el.find("input[type='radio']").removeAttr("rel");

          this.$el.find("span#selectinterface").remove();
          window.customizeFormElements.call();
        },

        enableSection                    : function()                  {
          if (this.model.get("ecoModeRequired"))
          {
            this.$el.find("select#interface").removeAttr("disabled");
            this.$el.find("select#interface").removeAttr("rel");

            this.$el.find(".oneInterfaceForEachZone").removeAttr("disabled");
            this.$el.find(".oneInterfaceForEachZone").removeAttr("rel");

            this.$el.find(".checkbox").remove();
            this.$el.find("span#selectinterface").remove();
          }
          this.$el.find(".radio").remove();

          this.$el.find("input[type='radio']").removeAttr("disabled");
          this.$el.find("input[type='radio']").removeAttr("rel");

          window.customizeFormElements.call();
        },

        populateDropDown                 : function()        {
          var interfaces = this.model.get("fetchedInterfaces");
          var dropDownView = this.$el.find("select#interface");
          dropDownView.children("option:first").attr("selected", "selected");
          dropDownView.children("option:not(:first)").remove();

          for (var i=0; i<interfaces.length;i++)
            dropDownView.append("<option value=\""+interfaces[i].packageClassId+"\">"+$.i18n._(interfaces[i].packageClassLabel)+"</option>");
        },

        ecoModeChanged                  : function(event)             {
          if (!this.model.get("inhibited")) {
            var ecoModeRequired   = (this.$el.find("input[name=\"activation\"]:checked").val()=="yes");

            this.model.set("ecoModeRequired",ecoModeRequired);
            this.model.trigger("insertEcoMode");
          }
        },

        showLoader                       : function()                  {
          this.$el.find(".mini-loader").fadeIn(200);
        },

        hideLoader                       : function(callback)          {
          var that = this;
          this.$el.find(".mini-loader").fadeOut(200, function()        {
            if (callback)
              callback.call(that);
          });
        },

        isOpen                           : function()                  {
          return this.$el.css("display")=="block";
        },

        interfaceChanged                 : function(event)             {

          //If no main control unit is selected set the model's id to UNDEFINED
          var interfacesId      = ($(event.target).val()==="") ? undefined : $(event.target).val();
          var selectedInterface = _.filter(this.model.get("fetchedInterfaces"), function(currentInterface){
            return currentInterface.packageClassId==interfacesId;
          });

          if (selectedInterface.length==1)
          {
            this.model.set("packageClassLabel", selectedInterface[0].packageClassLabel);
            this.model.set("packageClassId", interfacesId);
            _.extend(this.model.attributes,selectedInterface[0]);
          }
          else{
            this.model.set("packageClassLabel", "");
            this.model.set("packageClassId", undefined);
          }

          this.render();
        },

        oneInterfaceForEachZoneChanged   : function(event)             {
          var oneInterfaceForEachZone   = this.$el.find(".oneInterfaceForEachZone").is(":checked");
          this.model.set("oneInterfaceForEachZone",oneInterfaceForEachZone);
        },

        afterRender                      : function()                  {
          var that = this;


          if (!that.model.get("ecoModeRequired"))
            this.eventAggregator.trigger("view:disable", this);
          else
            this.eventAggregator.trigger("view:enable", this);

          setTimeout(function() {
            window.customizeFormElements.call();
          }, 0);

        },

        onClose                         : function() {
          //this.unbind("click .radio", this.ecoModeChanged);
          this.unbind("change #interface", this.interfaceChanged);
          this.unbind("click .checkbox", this.oneInterfaceForEachZoneChanged);
          this.eventAggregator.unbind("view:enable",this.enableSection);
          this.eventAggregator.unbind("view:disable",this.disableSection);
        }
      })

    },

    Model : genericElement.Model.extend({
      eventAggregator  : ecoModeEventAggregator,

      initialize         : function()                {
        var that = this;

        window.BticinoS4B.eventAggregator.bind("mainControlUnit:chosen",              this.mainControlUnitChosenEventHandler, this);

        this.unbind("change:packageClassId",                            this.idChanged, this);
        this.bind("change:packageClassId",                              this.idChanged, this);

        this.unbind("change:ecoModeRequired",                           this.updateView, this);
        this.bind("change:ecoModeRequired",                             this.updateView, this);

        this.fetchInterfaces();

        if ((this.get("packageClassId"))&&(this.get("packageClassId")!==""))
          this.getPackageDetails(this.get("packageClassId"));
      },

      mainControlUnitChosenEventHandler : function() {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber")==4)
          this.inhibitEcoMode();
        else
          this.deinhibitEcoMode();

        this.trigger("render:request");
      },

      updateView                                : function()                {
        if (this.get("ecoModeRequired"))
          this.eventAggregator.trigger("view:enable", this);
        else
          this.eventAggregator.trigger("view:disable", this);

        this.trigger("ecoMode:changed");
      },

      getPackageDetails                         : function(packageClassId)  {
        var that = this;
        var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

        BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
          data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
          var mainProduct       = _.filter(data.products,function(product) {return (product.mnemonic===1);})[0];
          var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

          _.extend(that.attributes, mainProduct);
          that.set("secondaryProducts", secondaryProducts);

          return mainProduct;
        });
      },

      fetchInterfaces    : function() {
        var that=this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("206", function(data) {
          //Sorting elements by packageClassId
          that.set("fetchedInterfaces", data.packages);

          that.get("fetchedInterfaces").sort(function (a, b) {
            if (parseInt(a.packageClassId, 10) < parseInt(b.packageClassId, 10))
              return -1;

            if (parseInt(a.packageClassId, 10) > parseInt(b.packageClassId, 10))
              return 1;

            return 0;
          });

          var currentpackageClassid = "-1";
          for (var i = 0; i<that.get("fetchedInterfaces").length; i++)
          {
            if (currentpackageClassid!==that.get("fetchedInterfaces")[i].packageClassId)
              currentpackageClassid = that.get("fetchedInterfaces")[i].packageClassId;
            else
            {
              that.get("fetchedInterfaces").splice(i,1);
              i--;
            }
          }

          if (that.get("view"))
            that.get("view").populateDropDown();
        });
      },

      idChanged          : function(e)               {

        if ((this.get("packageClassId"))&&(this.get("packageClassId")!==""))
        {
          this.getPackageDetails(this.get("packageClassId"));
          this.trigger("updateViews", this);
        }
        else
        {
          this.titleBarView.removeLabel();
        }
        this.trigger("ecoMode:changed");
      },

      removeValues       : function()                {
        this.set("image","");
        this.set("links",undefined);
        this.set("mnemonic","");
        this.set("name","");
        this.set("optionalPackages","");
        this.set("packageActuator","");
        this.set("packageClassId","");
        this.set("packageClassLabel","");
        this.set("packageInDepth","");
        this.set("packageLoad","");
        this.set("productDescription","");
        this.set("price","");
        this.set("productCode","");
        this.set("productInDepth","");
        this.set("productLabel","");
        this.set("packageClassDescription","");
        this.set("packageClassLabel","");
        this.set("packageClassId","");
      },

      disableSection     : function()                {
        var that = this;

        if (this.get("enabled"))
        {
          this.set("enabled",false);
          this.get("view").disableSection();
          this.titleBarView.removeLabel();
          if(this.get("view").isOpen())
            this.titleBarView.disable();
        }
      },

      enableSection      : function()                {
        var that = this;
        if (!this.get("enabled"))
        {
          this.set("enabled",true);
          this.get("view").enableSection();
          //if(!this.get("view").isOpen())
          //  this.titleBarView.enable();
        }
      },

      inhibitEcoMode : function() {
        this.set("enabled",false);
        this.set("ecoModeRequired",false);
        this.set("inhibited", true);
      },

      deinhibitEcoMode : function() {
        this.set("enabled",true);
        this.set("ecoModeRequired",false);
        this.set("inhibited", false);
      },

      onClose            : function() {
        this.unbind("change:packageClassId", this.idChanged);
        this.unbind("change:ecoModeRequired", this.updateView);
      }

    })

  });

  // Required, return the module for AMD compliance
  return ecoMode;

});